import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getCrmLeadsLinkedInList,
  postCrmLeadsCall,
} from "../../../api/crmLeads";
import { crmLinkedInTable } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import AgGridPaginatedTable from "../../../component/AgGridPaginatedTable";
import ItemDialogTabCall from "./item.dialog.call.desc";

export default function CRMLeadsLinkedInCardList() {
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const [itemDialog, setItemDialog] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  async function loadMasterData(limit, offset) {
    try {
      const { data } = await getCrmLeadsLinkedInList(
        {
          lead_id: params.id,
          limit: limit,
          offset: offset,
        },
        user.token
      );

      return {
        rows: data.records,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      //   setLoading(false);
    }
  }
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  const onItemDialogSubmit = async (postData) => {
    const combineData = { ...postData, lead_id: params.id };
    try {
      const { data } = await postCrmLeadsCall(combineData, user.token);
      refreshTable();
      dispatch(showAlert(data.msg));
      setItemDialog(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Lead Chats
          </Typography>
        </Box>

        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          <Button
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
              marginRight: "10px",
            }}
            onClick={() => {
              navigate(-2);
            }}
            className="blue-button"
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
            }}
            onClick={() => {
              setItemDialog(true);
            }}
            className="blue-button"
          >
            Create
          </Button>
        </Box>
      </Box>
      <br />
      <div>
        <AgGridPaginatedTable
          getTableRows={loadMasterData}
          columns={crmLinkedInTable}
          perPage={10}
          refreshCounter={tableRefreshCount}
          // rowSelection="single"
          //   onRowClicked={(params) => {
          //     setSelectedEmployeeRow(params.data.ep_id);
          //   }}
        />
      </div>

      <ItemDialogTabCall
        open={itemDialog}
        setOpen={setItemDialog}
        onSubmit={onItemDialogSubmit}
      />
    </Box>
  );
}
